module.exports = __webpack_public_path__ + "static/texas-sunset-zoom-e5b05af7f8fb94f8bacb0734613dcd4e.jpg";